import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalProvider } from "./Global";
import xml2js from "xml2js";

export const Providers = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    fetch("checklist.xml").then((res) => {
      res.text().then((xml) => {
        xml2js.parseString(
          xml,
          {
            explicitArray: false,
          },
          function (err, result) {
            setData(result.checklist);
            setIsLoading(false);
          }
        );
      });
    });

    return () => {};
  }, []);

  return (
    <Router basename="/subdir2">
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"></div>
        </div>
      ) : (
        <GlobalProvider data={data}>{children}</GlobalProvider>
      )}
    </Router>
  );
};
